import { useEffect, useState } from "react";
import useTspApiResource, { tspErrorMessage } from "./useTspApiResource";

// Data + mutations for the four "reusable location knowledge" pages
// (Contacts, Accommodation, Prasadam), which all talk to the same
// shape of API ({ list, create, remove } — see tspApiService.js). Records are
// global (not journey-scoped) per the backend's own design, so this loads a
// single page of everything rather than filtering by journey.
export default function useTspLocationResourceData(api) {
  const resource = useTspApiResource(() => api.list({ limit: 100 }), []);
  const [records, setRecords] = useState([]);

  useEffect(() => {
    if (resource.data) setRecords(resource.data);
  }, [resource.data]);

  // Returns { ok, message } — TspMasterDataCard shows `message` on refusal and
  // only clears the draft when `ok` is true.
  const add = async (body) => {
    try {
      const response = await api.create(body);
      setRecords((previous) => [response.data, ...previous]);
      return { ok: true };
    } catch (error) {
      return { ok: false, message: tspErrorMessage(error, "Could not save this entry.") };
    }
  };

  const remove = async (id) => {
    try {
      await api.remove(id);
      setRecords((previous) => previous.filter((row) => row.id !== id));
      return { ok: true };
    } catch (error) {
      return { ok: false, message: tspErrorMessage(error, "Could not remove this entry.") };
    }
  };

  return { loading: resource.loading, error: resource.error, reload: resource.reload, records, setRecords, add, remove };
}
